// extracted by mini-css-extract-plugin
export default {"nav":"VlOcMjMj","link":"_2S1yJ45A","linkActive":"_3ZoblZtX","title":"_26_xcXLw","hiddenOnMobile":"_4o7cQxWj","divider":"_1U67IKNT _4o7cQxWj","updateDot":"_13B-_mnh"};